import classNames from 'classnames';
import React from 'react';
import _ from 'underscore';

import Validation from 'modules/react-validation';

import HideValidationPopupsContext from 'sharedreact/contexts/HideValidationPopupsContext';
import Tooltip from 'sharedreact/components/Tooltip';

type Props = {
  className?: string,
  containerClassName?: string,
  id: string,
  type?: string,
  value: string | number,
  checked?: boolean,
  hint?: string,
  validationTooltipPlacement?: string,
  validationTooltipClassName?: string,
  placeholder?: string,
  disabled?: boolean,
  name?: string,
  autoComplete?: string,
  errorAnchorElement?: HTMLElement | null;
  inputRef?: (element: HTMLInputElement) => void,

  onBlur?: React.FocusEventHandler<HTMLInputElement>,
  onChange?: React.ChangeEventHandler<HTMLInputElement>,
  onKeyPress?: React.KeyboardEventHandler<HTMLInputElement>,
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>,
  onFocus?: React.FocusEventHandler<HTMLInputElement>
};

type DefaultProps = Required<Pick<Props, 'validationTooltipPlacement'>>;

type PropsWithDefaults = Omit<Props, keyof DefaultProps> & DefaultProps;

class ValidationInput extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    validationTooltipPlacement: 'auto right'
  };

  private input: HTMLInputElement | null;

  constructor (props: Props) {
    super(props);

    this.input = null;
  }

  renderInput () {
    const {
      id, className, type, value, checked, placeholder, disabled, name,
      autoComplete, onBlur, onChange, onKeyPress, onKeyDown, onFocus, inputRef
    } = this.props;

    if (checked) {
      return (
        <input
          className={classNames('esko_form-control', className)}
          id={id}
          type={type}
          value={value}
          checked
          placeholder={placeholder}
          disabled={disabled}
          name={name}
          autoComplete={autoComplete}
          onBlur={onBlur}
          onChange={onChange}
          onKeyPress={onKeyPress}
          onKeyDown={onKeyDown}
          onFocus={onFocus}
          ref={(ref) => {
            this.input = ref;
            if (inputRef != null && ref != null) {
              inputRef(ref);
            }
          }} />
      );
    } else {
      return (
        <input
          className={classNames('esko_form-control', className)}
          id={id}
          type={type}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          name={name}
          autoComplete={autoComplete}
          onBlur={onBlur}
          onChange={onChange}
          onKeyPress={onKeyPress}
          onKeyDown={onKeyDown}
          onFocus={onFocus}
          ref={(ref) => {
            this.input = ref;
            if (inputRef != null && ref != null) {  
              inputRef(ref);
            }
          }}
        />
      );
    }
  }

  override render (): React.ReactNode {
    const {
      containerClassName, hint,
      validationTooltipPlacement,
      validationTooltipClassName,
      errorAnchorElement
    } = (this.props as PropsWithDefaults);
    
    const hideValidationPopups = this.context;

    return (
      <div
        className={classNames(
          containerClassName,
          { 'has-error': hint },
          { 'has-feedback': hint }
        )}
      >
        <Tooltip show={hint != null && !hideValidationPopups} title={hint}
          className={validationTooltipClassName} placement={validationTooltipPlacement}
          parent={errorAnchorElement ?? this.input}
        />
        {this.renderInput()}
      </div>
    );
  }
}

ValidationInput.contextType = HideValidationPopupsContext;

export default Validation.factories.inputFactory(ValidationInput);
